import { Injectable } from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loadingState: Subject<boolean> = new Subject<boolean>();
  public loadingState$: Observable<boolean> = this._loadingState.asObservable();

  public setIsLoadingState(isLoading: boolean): void {
    this._loadingState.next(isLoading);
  }
}
